import api from "../company.api";

/** @deprecated use useCompanySettingsQuery instead, which uses react-query for caching */
const useCompanySettings = () => {
  const getCompanyPublicSettings = async (companyId?: string) => {
    if (!companyId) {
      throw new Error("No company id provided");
    }

    const response = await api.getCompanyPublicSettings(companyId);

    if (!response.isSuccess) {
      throw new Error(response.message);
    }

    return response.companySettings;
  };

  return {
    getCompanyPublicSettings,
  };
};

export default useCompanySettings;
